/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { LineItem } from "./LineItem";
import {
  LineItemFromJSON,
  LineItemFromJSONTyped,
  LineItemToJSON,
  LineItemToJSONTyped,
} from "./LineItem";
import type { Location } from "./Location";
import {
  LocationFromJSON,
  LocationFromJSONTyped,
  LocationToJSON,
  LocationToJSONTyped,
} from "./Location";

/**
 *
 * @export
 * @interface QuoteTestScenario
 */
export interface QuoteTestScenario {
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenario
   */
  scenarioId?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenario
   */
  groupId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof QuoteTestScenario
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenario
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenario
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenario
   */
  description?: string;
  /**
   *
   * @type {Array<LineItem>}
   * @memberof QuoteTestScenario
   */
  lineItems?: Array<LineItem>;
  /**
   *
   * @type {Location}
   * @memberof QuoteTestScenario
   */
  pickupLocation?: Location;
  /**
   *
   * @type {Location}
   * @memberof QuoteTestScenario
   */
  deliveryLocation?: Location;
  /**
   *
   * @type {string}
   * @memberof QuoteTestScenario
   */
  metadata?: string;
}

/**
 * Check if a given object implements the QuoteTestScenario interface.
 */
export function instanceOfQuoteTestScenario(
  value: object,
): value is QuoteTestScenario {
  return true;
}

export function QuoteTestScenarioFromJSON(json: any): QuoteTestScenario {
  return QuoteTestScenarioFromJSONTyped(json, false);
}

export function QuoteTestScenarioFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestScenario {
  if (json == null) {
    return json;
  }
  return {
    scenarioId: json["scenarioId"] == null ? undefined : json["scenarioId"],
    groupId: json["groupId"] == null ? undefined : json["groupId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    createdBy: json["createdBy"] == null ? undefined : json["createdBy"],
    title: json["title"] == null ? undefined : json["title"],
    description: json["description"] == null ? undefined : json["description"],
    lineItems:
      json["lineItems"] == null
        ? undefined
        : (json["lineItems"] as Array<any>).map(LineItemFromJSON),
    pickupLocation:
      json["pickupLocation"] == null
        ? undefined
        : LocationFromJSON(json["pickupLocation"]),
    deliveryLocation:
      json["deliveryLocation"] == null
        ? undefined
        : LocationFromJSON(json["deliveryLocation"]),
    metadata: json["metadata"] == null ? undefined : json["metadata"],
  };
}

export function QuoteTestScenarioToJSON(json: any): QuoteTestScenario {
  return QuoteTestScenarioToJSONTyped(json, false);
}

export function QuoteTestScenarioToJSONTyped(
  value?: QuoteTestScenario | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    scenarioId: value["scenarioId"],
    groupId: value["groupId"],
    createdAt: value["createdAt"],
    createdBy: value["createdBy"],
    title: value["title"],
    description: value["description"],
    lineItems:
      value["lineItems"] == null
        ? undefined
        : (value["lineItems"] as Array<any>).map(LineItemToJSON),
    pickupLocation: LocationToJSON(value["pickupLocation"]),
    deliveryLocation: LocationToJSON(value["deliveryLocation"]),
    metadata: value["metadata"],
  };
}
